export default {
  getCandidates(state) {
    return state.candidates;
  },
  getAllCandidates(state) {
    return state.candidate;
  },
  getAllJobPosts(state){
    return state.jobposts;  
  },
  getCandidateProfile(state){
    return state.candidateProfile;
  },
  getAppliedJobs(state){
    return state.jobApplies;
  },
  getCompForCand(state){
    return state.compListForCand;
  }
};
